import React, { useState } from "react"
import PropTypes from "prop-types"
import { Box, Button, Typography } from "@carrotfertility/carotene-core"
import { FormattedMessage, useIntl } from "react-intl"
import { useDidMount } from "../../../utils/Hooks"
import { useParams, useHistory } from "react-router-dom"
import { MerchantDeclineLoading } from "./MerchantDeclineLoading"
import { carrotClient } from "#/utils/CarrotClient"

const defaultState = {
  isLoading: true
}

export const NeedsApproval = () => {
  // @ts-expect-error TS(2339) FIXME: Property 'token' does not exist on type '{}'.
  const { token } = useParams()
  const [state, setState] = useState(defaultState)
  const history = useHistory()
  const intl = useIntl()

  useDidMount(() => {
    const checkIfMerchantValid = async () => {
      try {
        const result = await carrotClient.checkIfMerchantValid(token)

        if (result.isApproved) {
          history.push(`${token}/approve`)
          return
        }

        setState({
          ...state,
          // @ts-expect-error TS(2345) FIXME: Argument of type '{ companyAmount: any; companyCur... Remove this comment to see the full error message
          companyAmount: result.companyAmount,
          companyCurrencyCode: result.companyCurrencyCode,
          merchantAmount: result.merchantAmount,
          merchantCurrencyCode: result.merchantCurrencyCode,
          merchantName: result.merchantName,
          isLoading: false
        })
      } catch {
        history.push("error")
      }
    }

    checkIfMerchantValid().then()
  })

  if (state.isLoading) {
    return <MerchantDeclineLoading />
  }

  // @ts-expect-error TS(2339) FIXME: Property 'companyAmount' does not exist on type '{... Remove this comment to see the full error message
  const { companyAmount, companyCurrencyCode, merchantAmount, merchantCurrencyCode } = state
  let displayAmount = (
    <FormattedMessage
      defaultMessage="Amount: {displayMerchantAmount}"
      values={{
        displayMerchantAmount: merchantAmount
      }}
    />
  )

  if (merchantCurrencyCode && companyAmount) {
    const displayMerchantAmount = intl.formatNumber(merchantAmount, {
      style: "currency",
      currency: merchantCurrencyCode,
      currencyDisplay: "narrowSymbol"
    })

    const displayCompanyAmount = intl.formatNumber(companyAmount, {
      style: "currency",
      currency: companyCurrencyCode,
      currencyDisplay: "narrowSymbol"
    })

    displayAmount =
      merchantCurrencyCode && companyCurrencyCode && merchantCurrencyCode === companyCurrencyCode ? (
        <FormattedMessage
          defaultMessage="Amount: {displayMerchantAmount}"
          values={{
            displayMerchantAmount
          }}
        />
      ) : (
        <FormattedMessage
          defaultMessage="Amount: {displayMerchantAmount} ({displayCompanyAmount})"
          description="currency amount displaying amount in the merchant's currency, followed by the same amount in the company's currency in parantheses"
          values={{
            displayMerchantAmount,
            displayCompanyAmount
          }}
        />
      )
  }

  return (
    <>
      <Box sx={(theme) => ({ marginBlockStart: theme.tokens.spacing.xl })}>
        <Typography variant="h3">
          <FormattedMessage defaultMessage="Carrot Card declined" />
        </Typography>
      </Box>
      <Box sx={(theme) => ({ marginBlockStart: theme.tokens.spacing.md })}>
        <Typography>
          <FormattedMessage defaultMessage="Your Carrot Card transaction was declined because we don't recognize this provider." />
        </Typography>
      </Box>
      <Box sx={(theme) => ({ marginBlockStart: theme.tokens.spacing.md })}>
        <Typography sx={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
          <FormattedMessage
            defaultMessage="Provider name: {merchantName}"
            values={{
              // @ts-expect-error TS(2339) FIXME: Property 'merchantName' does not exist on type '{ ... Remove this comment to see the full error message
              merchantName: state.merchantName
            }}
          />
        </Typography>
      </Box>
      <Typography>{displayAmount}</Typography>
      <Box sx={(theme) => ({ marginBlockStart: theme.tokens.spacing.md })}>
        <Typography>
          <FormattedMessage defaultMessage="Is this provider an eligible Carrot provider?" />
        </Typography>
      </Box>
      <Box sx={(theme) => ({ marginBlockStart: theme.tokens.spacing.lg })}>
        <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
          <Button component="a" href={`${token}/approve`}>
            <FormattedMessage defaultMessage="Yes" />
          </Button>
          <Box sx={(theme) => ({ marginInlineEnd: theme.tokens.spacing.md })} />
          <Button component="a" href={`${token}/deny`} variant="outlined" color="secondary">
            <FormattedMessage defaultMessage="I'm not sure" />
          </Button>
        </Box>
      </Box>
    </>
  )
}

NeedsApproval.propTypes = {
  status: PropTypes.string,
  amount: PropTypes.string,
  merchantName: PropTypes.string
}
